module.exports = require("element-ui/lib/mixins/locale");